import EditInputWithLabel from './EditInputWithLabel';

export default EditInputWithLabel;
